module.exports = __webpack_public_path__ + "static/media/novaLofi.41895b68.mp3";